<template>
  <v-card
    ripple
    class="card--mirror"
    @click="openMirrorItemDetails"
    :ref="reference"
    elevation="3"
  >
    <div class="card-content">
      <div class="card-content-header">
        <div
          class="card-content-header-item"
          :class="textColorClassFromType('card', activityType)"
        >
          <v-icon>mdi-label</v-icon>
          {{ itemTypeDisplay(activityType) }}
        </div>

        <div class="card-content-header-item">
          <v-icon>mdi-television</v-icon>
          {{ activity.program_tag }}
        </div>

        <div class="card-content-header-time">
          <v-icon>access_time</v-icon>
          <div class="time">
            {{ formatSeconds(activity.start_time, true) }}
          </div>
        </div>
      </div>

      <div class="card-content-title">
        {{ activity.title || emptyField }}
      </div>

      <div class="card-content-metadata">
        <div
          v-for="data in metadata"
          :key="data.name"
          class="card-content-metadata__item"
        >
          <div>{{ data.name }}</div>
          <div>{{ data.value }}</div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { formatSeconds } from '@/utils/date.js';
import {
  formatField,
  textColorClassFromType,
  itemTypeDisplay,
  bgColorClassCategoryType,
} from '@/utils/mirrorFormatter.js';
import { mapState } from 'vuex';
import { actions, categories } from '@/constants/analytics.js';

export default {
  props: {
    activity: Object,
    activityType: String,
    reference: String,
  },
  data() {
    return {
      emptyField: '--',
    };
  },
  computed: {
    ...mapState({
      lastMirrorAcessed: state => state.mirror.lastMirrorAcessed,
    }),

    metadata() {
      const {
        reporter,
        presenter,
        speaking_time,
        tape_time,
        total_time,
        page,
      } = this.activity;

      const metadatas = [
        {
          name: 'PG',
          value: page || this.emptyField,
        },
        {
          name: 'tCAB',
          value: formatSeconds(speaking_time) || this.emptyField,
        },
        {
          name: 'tVT',
          value: formatSeconds(tape_time) || this.emptyField,
        },

        {
          name: 'tMAT',
          value: formatSeconds(total_time) || this.emptyField,
        },
        {
          name: 'LOC',
          value: formatField(presenter) || this.emptyField,
        },
        {
          name: 'REP',
          value: formatField(reporter) || this.emptyField,
        },
      ];
      if (this.$vuetify.breakpoint.mdOnly)
        return metadatas.filter(
          metadata => !['tCAB', 'tVT'].includes(metadata.name),
        );
      return metadatas;
    },
  },
  mounted() {
    const lastMirror = this.$refs[this.lastMirrorAcessed];
    if (lastMirror) {
      lastMirror.$el.scrollIntoView({
        behavior: 'smooth',
      });
    }
  },
  methods: {
    formatSeconds,
    itemTypeDisplay,
    formatField,
    bgColorClassCategoryType,
    textColorClassFromType,

    openMirrorItemDetails() {
      this.sendMirrorCardAnalytics();
      this.$emit('openMirrorItemDetails', this.activity);
      this.$store.dispatch('mirror/handleLastMirror', this.reference);
    },

    categoryAnalytics() {
      return this.activity.is_historic
        ? categories.historic_mirror
        : categories.mirror;
    },
    sendMirrorCardAnalytics() {
      this.$store.dispatch('analyticsEvent', {
        category: categories.mirror,
        action: actions.activityDetailClicked,
        label: `${this.activity.place}-${this.activity.program_tag}-${this.activity.title}`,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/mirror-card.scss';
</style>
